import {
    CustomizationData,
    WidgetConfig,
} from "@lib/CustomizationManager/types";

export interface GwFromShopifyEmbed {
    registerWidgetCustomization: (
        selectWidget: (config: WidgetConfig) => boolean,
        customizeWidget: (config: WidgetConfig) => CustomizationData
    ) => void;
}

// Do not change this prefix, it is used by customizations.
const STYLE_PREFIX = "gw-style-for-";

/**
 * Automatically registers widget customizations based
 * on <style> elements whose id starts with the prefix.
 *
 * IMPORTANT: This function must be executed at the very beginning
 * of the storefront, before any widgets initialize.
 */
export function registerStyleBasedCustomizations() {
    if (!window.gw) return;

    const registerWidgetCustomization = (window.gw as GwFromShopifyEmbed)
        .registerWidgetCustomization;

    if (typeof registerWidgetCustomization !== "function") return;

    const styles = document.querySelectorAll<HTMLStyleElement>(
        `style[id^="${STYLE_PREFIX}"]`
    );

    styles.forEach((styleElement) => {
        const widgetName = styleElement.id.slice(STYLE_PREFIX.length).trim();
        if (!widgetName) return;

        registerWidgetCustomization(
            (widgetConfig) => widgetConfig.widgetName === widgetName,
            () => ({ styleElement })
        );
    });
}
